module.exports = __webpack_public_path__ + "static/media/photo-3.e80e13ac.avif";